import Camera from "./CameraComponent.jsx";

export default Camera;
